import EventBus from "./event-bus";

const axios = require('axios');
import {errorHandler} from "./common";


export function getSetting(type, field) {
  return new Promise(function(resolve, reject) {
    let url = process.env.ROOT_API + 'admin/setting?';
    url += 'type=' + type + '&field=' + field;
    axios.get(process.env.ROOT_API + 'admin/setting?',  {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    }).then(function(response) {
      let data = response.data;
      resolve(data);
    }).catch(function(err) {
      errorHandler(err);
      reject(err);
    })
  })
}
export function getSettings(type) {
  return new Promise(function(resolve, reject) {
    let url = process.env.ROOT_API + 'admin/settings?type=' + type;
    axios.get(url,  {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    }).then(function(response) {
      let data = response.data;
      resolve(data);
    }).catch(function(err) {
      errorHandler(err);
      reject(err);
    })
  })
}

export function deleteSetting(id) {
  return new Promise(function(resolve, reject) {
    axios.delete(process.env.ROOT_API + 'admin/setting?id=' + id,  {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    }).then(function(response) {
      let data = response.data;
      resolve(data);
    }).catch(function(err) {
      errorHandler(err);
      reject(err);
    })
  })
}
export function updateSetting(item) {
  return new Promise(function(resolve, reject) {
    axios.post(process.env.ROOT_API + 'admin/setting', JSON.stringify(item),  {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function(response) {
      let data = response.data;
      resolve(data);
    }).catch(function(err) {
      errorHandler(err);
      reject(err);
    })
  })
}
export function updateSettings(items) {
  return new Promise(function(resolve, reject) {
    axios.post(process.env.ROOT_API + 'admin/settings', JSON.stringify(items),  {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function(response) {
      let data = response.data;
      resolve(data);
    }).catch(function(err) {
      errorHandler(err);
      reject(err);
    })
  })
}

export function getDefaultSettings() {
  let list= [
    {
      id:0,
      type:'setting',
      description:'Company Name',
      field:'company_name',
      valueType:'text',
      text:'',
    },
    {
      id:0,
      type:'setting',
      description:'Company Address',
      field:'company_address',
      valueType:'textarea',
      text:'',
    },
    {
      id:0,
      type:'setting',
      description:'Company Tel',
      field:'company_tel',
      valueType:'text',
      text:'',
    },
    {
      id:0,
      type:'setting',
      description:'Company Mobile',
      field:'company_mp',
      valueType:'text',
      text:'',
    },
    {
      id:0,
      type:'setting',
      description:'Company VAT',
      field:'company_vat',
      valueType:'text',
      text:'',
    },
    {
      id:0,
      type:'setting',
      description:'Bank Account',
      field:'company_account',
      valueType:'textarea',
      text:'',
    },
    {
      id:0,
      type:'setting',
      description:'Bank Account Ko',
      field:'company_account_kr',
      valueType:'textarea',
      text:'',
    },
    {
      id:0,
      type:'setting',
      description:'LOGO',
      field:'company_logo',
      valueType:'image',
      text:'',
    },
    {
      id:0,
      type:'setting',
      description:'Signature',
      field:'company_signature',
      valueType:'image',
      text:'',
    },

  ];
  return list;

}



// WEBPACK FOOTER //
// ./src/api/settings.js